import { z } from 'zod';

export const zodConnectionsDataExchangeSearchParametersSchema = z.object({
  freeTextFilter: z.string().optional().catch(''),
  receiverId: z.uuid().optional().catch(undefined),
  senderId: z.uuid().optional().catch(undefined),
});

export const zodConnectionsCompanySearchParametersSchema = z.object({
  freeTextFilter: z.string().optional().catch(''),
});
